import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class PulDarSandogh extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading:true,
            activeTab: 1,
            data:{"CodeMelli":"2142596347","BId":1358323,"FullBNo":"96/04/700/8055/4001559","SodurDate":"1396/02/30","LastBNo":null,"AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","BimeGozarText":"علي ولائي کد 2599583 به نفع بانک صنعت و معدن  شعبه ساري","CodMelliOrEconomic":"2142596347","BimegozarAddress":"استان ‏مازندران‏،شهر آمل-شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي","BimegozarTel":"01222523538","BimeKindText":"صنعتي","ActivityKindText":"‏چراغ روشنايى خيابان ـ توليد‏","ActivitySharh":"توليد چراغ روشنايي گاز","AddressText":"استان ‏مازندران‏،شهر آمل ، شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي","Moddat":365,"BeginDate":"1396/03/01","EndDate":"1397/03/01","AllRiskText":" آتش سوزي ، صاعقه ، انفجار ، زلزله و آتشفشان ، سيل و طغيان آب ، طوفان و گردباد و تندباد ، ضايعات ذوب برف و آب باران ، ريزش سقف ناشي ازسنگيني برف ، تركيدگي لوله آب ، انفجار ظروف تحت فشار صنعتي ، دفرمه شدن ظروف تحت فشار","MarhunatSarmaye":1024000000,"MarhunatHbStr":"883,650 ريال","HBStr":"883,650 ريال","SumSarmayeStr":"1,024,000,000 ريال","SAAMPercent":"%9","MaliatAvarez":"79,529 ريال","HBWithAvarezStr":"963,179 ريال","Reshte":1,"Endorsement":[],"Mavared":[{"ShahrdariAvarezNerkh":3,"AfzoodeMaliatNerkh":6,"BId":1358323,"ElhNo":0,"GId":349,"MoredeBimeText":null,"MavaredTitr":"عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :","BNo":"96/04/700/8055/4001559","SodurText":"شعبه ساري کد 700","AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","LastBNo":null,"PishnahadDate":"1396/02/16","SodurDate":"1396/02/30","SumSarmaye":1024000000,"SumSarmayeStr":"يك ميليارد و بيست و چهار ميليون","HB":883650,"HBText":"هشتصد و هشتاد و سه هزار و ششصد و پنجاه","MoneyUnitText":"ريال","Sharh":"ساختمان توليد ، اداري  با مساحت تقريبي 366  مترمربع  به  انضمام کليه تاسيسات مربوطه جمعا\" به ارزش","Sarmaye":"253,000,000","MaxCommitment":"253,000,000","Nerkh":"0.75","MHB":"126,500","Radif":"1","InnerOrder":1},{"ShahrdariAvarezNerkh":3,"AfzoodeMaliatNerkh":6,"BId":1358323,"ElhNo":0,"GId":349,"MoredeBimeText":null,"MavaredTitr":"عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :","BNo":"96/04/700/8055/4001559","SodurText":"شعبه ساري کد 700","AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","LastBNo":null,"PishnahadDate":"1396/02/16","SodurDate":"1396/02/30","SumSarmaye":1024000000,"SumSarmayeStr":"يك ميليارد و بيست و چهار ميليون","HB":883650,"HBText":"هشتصد و هشتاد و سه هزار و ششصد و پنجاه","MoneyUnitText":"ريال","Sharh":"ماشين آلات  و تجهيزات طبق ليست پيوست نامه شماره 2148/م/الف بانک صنعت و معدن ساري جمعا\" به ارزش","Sarmaye":"771,000,000","MaxCommitment":"771,000,000","Nerkh":"0.9","MHB":"385,500","Radif":"2","InnerOrder":1}],"Bill":[],"PishnahadNo":null,"PishnahadDate":"1396/02/16","ElhNo":0,"ErrorMessage":null}
        }
        this.state.data = {} ;
        
        this.state.btns=[];
       
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Oth/api/OthMoneySandogh/PolicyInfo",
           
                {id: this.currentSodurId, codeMelli:  UserManager.MelliCode()}
            ),
            BimeManager.header())
            .then((result)=>{
                this.setState({data:result.data,isLoading:false})
                console.log('poldarsandogh***', this.state.data )
            })
            .catch((error) => { alert(error) })   
    }

    pagechange(bid,reshte) {
        
        PageManager.changePage(Config.p_pardakhtman,[bid,reshte]);
    }
    render() {
        return (

            <div>
               <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>وجوه در صندوق</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({activeTab:1}) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({activeTab:2}) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                    <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({activeTab:3}) }}>
                         مشخصات صندوق
                        </NavLink>
                        </NavItem>
                        <NavItem>
                    <NavLink
                            className={{ active: this.state.activeTab === 4 }}
                            onClick={() => { this.setState({activeTab:4}) }}>
                           مشخصات وجوه صندوق
                        </NavLink>
                        </NavItem>
                        
                    <NavItem>
                        <NavLink onClick={() => {this.pagechange(this.currentSodurId,this.state.data.Reshte)}}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                </Nav>
               

{ (!this.state.isLoading)?(
        
         
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                        <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{this.state.data.MoredBimeKindText}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                        <Col sm="12"><span className="bold-head">واحد معرف:</span>{this.state.data.AgentCodeText}</Col>
                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.CodeSodurText}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{this.state.data.BNSodurDate}</Col>
                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{this.state.data.BimegozarPrintName}</Col>
                                        <Col sm="12"><span className="bold-head">نشانی:</span>{this.state.data.BGAddress}</Col>
                                        <Col sm="12"><span className="bold-head">نوع بیمه گذار:</span>{this.state.data.BimeGozarKindText}</Col>
                                        <Col sm="12"><span className="bold-head">ذینفع:</span>{this.state.data.ZinafText}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه سال قبل:</span>{this.state.data.LastBnoText}</Col>
                                        <Col sm="12"><span className="bold-head">مدت اعتبار بیمه نامه:</span>{this.state.data.Moddat}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ شروع:</span>{this.state.data.BeginDate}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ پایان:</span>{this.state.data.EndDate}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه:</span>{this.state.data.HBText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه به حروف:</span>{this.state.data.HBText}</Col>
                                        <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{this.state.data.AfzoodehMaliatText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{this.state.data.ShahrdariAvarezText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه قابل پرداخت:</span>{this.state.data.HBKolText_WithMoneyUnit}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه قابل پرداخت به حروف:</span>{this.state.data.HBLiteralText_WithoutMoneyUnit}</Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.OthMoneyEndorsement)?  this.state.data.OthMoneyEndorsement.map((endorsement)=>{
                                                return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.BId}</Col>
                                                            <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.MoredBimeKindText}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNo}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{endorsement.SodurDate}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{endorsement.ActiveDate}</Col>
                                                            
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                            <Col sm="12"><span className="bold-head">نماینده/کارگزار:</span>{endorsement.AgentCodeText}</Col>
                                                            <Col sm="12"><span className="bold-head">واحد صدور:</span>{endorsement.CodeSodurDisplayName}</Col>
                                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozarText}</Col>
                                                            <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{endorsement.Sharh}</Col>
                                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.ShahrdariAvarezText)+('ریال')}</Col>
                                                          
                                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.AfzoodehMaliatText)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHB)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHBTotal)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHB)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHBTotal)+('ریال')}</Col>
                                                           <br/>
                                                           </div>
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                        <TabPane tabId={3}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.OthMoneySandoghSandoghDesc) ? this.state.data.OthMoneySandoghSandoghDesc.map((moshakhasatsandogh) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">مشخصات صندوق:</span>{moshakhasatsandogh.SandughDesc}</Col>
                                                        <Col sm="12"><span className="bold-head">محل نگهداری:</span>{moshakhasatsandogh.SandughLocation}</Col>
                                                        <Col sm="12"><span className="bold-head">میزان تعهد:</span>{moshakhasatsandogh.SarmayeText+'ریال'}</Col>
                                                           <br />
                                                         </div>
                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                         <TabPane tabId={4}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.OthMoneySandoghMoneyDesc) ? this.state.data.OthMoneySandoghMoneyDesc.map((vojoh) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">شرح مورد بيمه:</span>{vojoh.MoredBimeSharh}</Col>
                                                        <Col sm="12"><span className="bold-head">محل پوشش بيمه ای:</span>{vojoh.PusheshMahal}</Col>
                                                        <Col sm="12"><span className="bold-head">جمع موجودی گاو صندوق ها:</span>{vojoh.GavSandughSarmayeText}</Col>
                                                        <Col sm="12"><span className="bold-head">وجوه نقد در دستگاه خود پرداز:</span>{vojoh.KhodPardazSarmayeText}</Col>
                                                        <Col sm="12"><span className="bold-head">وجوه نقد پشت باجه:</span>{vojoh.BojeSarmayeText}</Col>
                                                        <Col sm="12"><span className="bold-head">درصد فرانشيز:</span>{vojoh.DarsadFranshiz}</Col>
                                                        <Col sm="12"><span className="bold-head">حداقل فرانشیز:</span>{vojoh.MinFranshizText_WithMoneyUnit}</Col>
                                                        <Col sm="12"><span className="bold-head">حداکثر تعهد در طول اعتبار بيمه نامه:</span>{vojoh.BNSarmayeText}</Col>
                                                        <Col sm="12"><span className="bold-head">نرخ حق بیمه:</span>{libs.StringFunctions.currancyPrint(vojoh.Nerkh)+('ریال')}</Col>
                                                         <br />
                                                         </div>
                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={5}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.OthMoneyCurrancyferanshiz) ? this.state.data.OthMoneyCurrancyferanshiz.map((feranshiz) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">درصد فرانشیز:</span>{feranshiz.DarsadFranshiz}</Col>
                                                        <Col sm="12"><span className="bold-head">حداقل فرانشیز:</span>{feranshiz.MinFranshiz}</Col>
                                                         <br />
                                                         </div>
                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={6}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.FinalHV) ? this.state.data.FinalHV.map((haghbimenahai) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(haghbimenahai.afzoodehMaliat)+('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(haghbimenahai.ShahrdariAvarez)+('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه:</span>{libs.StringFunctions.currancyPrint(haghbimenahai.HBBase)+('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به عدد:</span>{libs.StringFunctions.currancyPrint(haghbimenahai.HBWithAvarez)+('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به حروف:</span>{haghbimenahai.HBWithAvarezLitText}</Col>
                                                         <br />
                                                         </div>
                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                </TabContent>):(<ui.Preloader />)
                
            
            
         }
         </div>
        );
    }
}


export default PulDarSandogh;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/PulDarSandogh.js